import { createClient, Session } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY)')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,      // Automatically refresh tokens before expiry
    persistSession: true,         // Persist session in localStorage
    detectSessionInUrl: true,     // Detect OAuth/magic link redirects
  },
})

/**
 * Module-level session cache to avoid calling getSession() which can deadlock
 * when called from inside onAuthStateChange callbacks.
 *
 * Updated by AuthContext when session changes.
 * Read by apiClient to get the current access token.
 */
let cachedSession: Session | null = null;

export function setCachedSession(session: Session | null): void {
  cachedSession = session;
}

export function getCachedSession(): Session | null {
  return cachedSession;
}
